import Box from '@zenbusiness/zui/Box';
import Chip from '@zenbusiness/zui/Chip';
import DialogActions from '@zenbusiness/zui/DialogActions';
import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ComparisonTitle = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ComparisonTitle',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(1),
  }),
});

export const ServiceIconStack = superstyled({
  tag: Stack,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ServiceIconStack',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(3),
  }),
});

export const ServiceIcon = superstyled({
  tag: Box,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ServiceIcon',
  styles: ({ theme }) => ({
    width: 96,
    height: 96,
    marginBottom: theme.spacing(1),
  }),
});

export const ServiceName = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ServiceName',
  styles: {
    textTransform: 'capitalize',
  },
});

export const ProductGrid = superstyled({
  tag: Grid,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ProductGrid',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(3),
  }),
});

export const ProductIntervalLabel = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ProductIntervalLabel',
  styles: ({ theme }) => ({
    textTransform: 'capitalize',
    marginBottom: theme.spacing(1),
    color: 'inherit',
  }),
});

export const ProductPriceText = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ProductPriceText',
  styles: {
    fontSize: 16,
    color: 'inherit',
  },
});

export const ProductChip = superstyled({
  tag: Chip,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ProductChip',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(0.5),
  }),
});

export const ProductNoteText = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ProductNoteText',
  styles: {
    fontSize: 12,
    display: 'block',
    color: 'inherit',
  },
});

export const ModalActions = superstyled({
  tag: DialogActions,
  name: 'ChangeBillingIntervalAnnualComparison',
  slot: 'ModalActions',
  styles: ({ theme }) => ({
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }),
});
